import { Component, Input , Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { MenuItem } from 'primeng/api';


@Component({
  selector: 'PageHeader' ,
  templateUrl: './Pageheader.component.html',

})
export class PageHeaderComponent implements OnInit, OnChanges{


  // count the clicks
  private clickTimeout = null;
  menuItems: MenuItem[] = [];
  constructor( private router: Router, private _location: Location) {}

  @Input() title: string = '';
  @Input('showAddNew') showAddNew: boolean;
  @Input() showMainListing: boolean = true;
  @Input() showScanbox: boolean = false;
  @Input() showCheckInInventory: boolean = false;
  @Input() showSearch: boolean = true;
  @Input() showNote: boolean = false;
  @Input() showCancel: boolean = false;
  @Input() showSave: boolean = false;
  @Input() showEdit: boolean = false;
  @Input() showPreviousPage: boolean = false;
  @Input() MainListingText: string = 'Cancel/Main Listing';
  @Input() addurl: string = '';
  @Input() mainlisturl: string = '';
  @Output() searchShowChange = new EventEmitter<boolean>();
  @Output() CancelEvent = new EventEmitter<boolean>();
  @Output() SaveEvent = new EventEmitter<boolean>();
  @Output() EditEvent = new EventEmitter<boolean>();
  @Output() SearchTextChange = new EventEmitter<string>();
  @Output() addNoteClick = new EventEmitter<boolean>();
  @Input() showDelete: boolean = false;
  @Input() showPrint: boolean = false;
  @Output() DeleteEvent = new EventEmitter<boolean>();
  @Output() PrintEvent = new EventEmitter<boolean>();
  @Input() showImportContact = false;
  @Input() showDownloadTemplate = false;
  @Output() importContactClick = new EventEmitter<void>();
  @Output() downloadTemplateClick = new EventEmitter<void>();
  searchTextValue: string = '';
  @Input() isSearchOpen = false;
  @Input() menuMode = false;             
  @Input() showImportParts = false;
  @Input() showImportEquipment = false;
  @Input() showImportVendor = false;
  @Output() importInventoryPartsClick = new EventEmitter<void>();
  @Output() importInventoryEquipmentClick = new EventEmitter<void>();
  @Output() importVendorClick = new EventEmitter<void>();

   ngOnInit() {
      this.buildMenuItems();
    }

    ngOnChanges(changes: SimpleChanges): void {
    // If any @Input changes, rebuild the menu
      if (Object.keys(changes).length > 0) {
        this.buildMenuItems();
      }
    }
  
    buildMenuItems() {
    this.menuItems = [
      this.showAddNew ? { label: 'Add New', icon: 'pi pi-plus', command: () => this.RouteClick(this.addurl) } : null,
      this.showEdit ? { label: 'Edit', icon: 'pi pi-pencil', command: () => this.EditClick() } : null,
      this.showSave ? { label: 'Save', icon: 'pi pi-save', command: () => this.SaveClick() } : null,
      this.showCancel ? { label: 'Cancel', icon: 'pi pi-times', command: () => this.CancelClick() } : null,
      this.showPrint ? { label: 'Print Schedule', icon: 'pi pi-print', command: () => this.Print() } : null,
      this.showNote ? { label: 'Add Note', icon: 'pi pi-file-edit', command: () => this.AddNoteClick() } : null,
      this.showPreviousPage ? { label: 'Previous Page', icon: 'pi pi-arrow-left', command: () => this.PreviousPageClick() } : null,
      this.showDownloadTemplate ? { label: 'Download Template', icon: 'pi pi-download', command: () => this.DownloadTemplate() } : null,
      this.showImportContact ? { label: 'Import Contact', icon: 'pi pi-upload', command: () => this.ImportContact() } : null,
      this.showImportParts ? { label: 'Import Parts', icon: 'pi pi-upload', command: () => this.ImportInventoryParts() } : null,
      this.showImportEquipment ? { label: 'Import Equipment', icon: 'pi pi-upload', command: () => this.ImportInventoryEquipment() } : null,
      this.showImportVendor ? { label: 'Import Vendor', icon: 'pi pi-upload', command: () => this.ImportVendor() } : null,      
      this.showMainListing ? {
        label: this.MainListingText,
        icon: this.MainListingText === 'Cancel' ? 'pi pi-times' : 'pi pi-list',
        command: () => this.RouteClick(this.mainlisturl)
      } : null,
      this.showSearch ? {
        label: 'Advanced Search',
        icon: this.isSearchOpen ? 'pi pi-times' : 'pi pi-search',
        styleClass: this.isSearchOpen ? 'p-menuitem-danger' : '', // optional red highlight when open
        command: () => this.SearchClick()
      } : null
    ].filter(Boolean) as MenuItem[];
  }

  RouteClick(value) {
    this.router.navigate([value]);
  }

  @Input()
  get searchText() {
    return this.searchTextValue;
  }
  set searchText(val) {
    this.searchTextValue = val;
    this.SearchTextChange.emit(this.searchTextValue);
  }

  SearchClick() {
     if (this.isSearchOpen) {
        this.searchTextValue = 'Advanced Search';
     } else {
        this.searchTextValue = 'Cancel';
     }
     this.isSearchOpen =! this.isSearchOpen;
     this.searchShowChange.emit(this.isSearchOpen);
  }

  PreviousPageClick() {
    this._location.back();
  }

  SaveClick() {

    if (this.clickTimeout) {
      this.setClickTimeout(() => {});
    } else {
      // if timeout doesn't exist, we know it's first click
      // treat as single click until further notice
      this.setClickTimeout((itemId) =>
        this.handleSingleClick(itemId));
    }
  }

  CancelClick() {
    this.CancelEvent.emit();
  }

  EditClick() {

    this.EditEvent.emit();
 }

  AddNoteClick() {

      this.addNoteClick.emit();
  }
  DeleteClick() {
     this.DeleteEvent.emit();
  }

  Print()
  {
    this.PrintEvent.emit();
  }

  ImportContact() {
    this.importContactClick.emit();
  }

  DownloadTemplate() {
    this.downloadTemplateClick.emit();
  }

  ImportInventoryParts() {
    this.importInventoryPartsClick.emit();
  }

  ImportInventoryEquipment() {
    this.importInventoryEquipmentClick.emit();
  }


  ImportVendor() {
    this.importVendorClick.emit();
  }

  // sets the click timeout and takes a callback
// for what operations you want to complete when
// the click timeout completes
public setClickTimeout(callback) {
  // clear any existing timeout
  clearTimeout(this.clickTimeout);
  this.clickTimeout = setTimeout(() => {
    this.clickTimeout = null;
    callback();
  }, 200);
}
public handleSingleClick(itemId: string) {
   //The actual action that should be performed on click
   this.SaveEvent.emit();
}
}
